import { useEffect, useState } from 'react';
import { useChatContext } from '../../../context';
export const useChannelMembershipState = (channel) => {
    const [membership, setMembership] = useState(channel?.state.membership || {});
    const { client } = useChatContext();
    useEffect(() => {
        if (!channel)
            return;
        const subscriptions = ['member.updated'].map((v) => client.on(v, () => {
            setMembership(channel.state.membership);
        }));
        return () => subscriptions.forEach((subscription) => subscription.unsubscribe());
    }, [client, channel]);
    return membership;
};
